import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/home'
import ResearchAndDevelopment from '../views/researchDevelopment'
import Education from '../views/education'
import Security from '../views/security'
import VisitorAnalysis from '../views/visitoranalysis'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/visitor-analysis',
    name: 'VisitorAnalysis',
    component: VisitorAnalysis
  },
  {
    path: '/research-and-development',
    name: 'ResearchAndDevelopment',
    component: ResearchAndDevelopment
  },
  {
    path: '/education',
    name: 'Education',
    component: Education
  },
  {
    path: '/securtiy-technology',
    name: 'SecurityTechnology',
    component: Security
  }
  // ,
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

export default router
